import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetUserRole = async (uid) => {
  /**
   * input: uid: users id
   * output: user role
   * description: fetches user role
   */

  try {
    const userDoc = await doc(db, "users", uid);
    const userDocSnapshot = await getDoc(userDoc);
    const userDocDetails = userDocSnapshot.data();
    return userDocDetails.role;
  } catch (error) {
    console.log(error);
  }
};

export default GetUserRole;
